import React from "react";
import { AlertIcon, CheckCircleIcon, InfoIcon, LockIcon, XCircleIcon } from "../../../img/svg/adminIcons";

type CalloutTone = "info" | "warning" | "danger" | "success" | "gold";

const tones: { [key in CalloutTone]: string } = {
    info: "bg-gray-50 border-gray-200 text-gray-700 [&_.callout-icon]:text-gray-500",
    warning: "bg-amber-50 border-amber-200 text-amber-900 [&_.callout-icon]:text-amber-600",
    danger: "bg-red-50 border-red-200 text-red-800 [&_.callout-icon]:text-red-600",
    success: "bg-emerald-50 border-emerald-200 text-emerald-800 [&_.callout-icon]:text-emerald-600",
    gold: "bg-secondary/5 border-secondary/40 text-gray-800 [&_.callout-icon]:text-secondary-dark",
}

// caixa de aviso/explicação (regras, bloqueios, instruções)
export default function AdminCallout({ tone = "info", title, children, icon, className = "" }: { tone?: CalloutTone, title?: React.ReactNode, children?: React.ReactNode, icon?: "lock", className?: string }) {

    const Icon = icon === "lock" ? LockIcon : tone === "warning" ? AlertIcon : tone === "danger" ? XCircleIcon : tone === "success" ? CheckCircleIcon : InfoIcon;

    return (
        <div className={`flex gap-3 rounded-xl border p-4 text-sm ${tones[tone]} ${className}`}>
            <span className="callout-icon mt-0.5"><Icon width="18px" /></span>
            <div className="min-w-0 flex-1">
                {
                    title ?
                        <p className="font-bold mb-1">{title}</p>
                        : null
                }
                <div className="leading-relaxed">{children}</div>
            </div>
        </div>
    )
}
